<template>
  <v-flex>
    <v-btn icon class="mx-0" @click.native="addRole"><v-icon>add</v-icon></v-btn>
    <v-data-table :headers="headers" :loading="loadingState" :items="roles" hide-actions class="elevation-1">
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ props.item.id }}</td>
        <td class="text-xs-left">{{ props.item.name }}</td>
        <td class="text-xs-left">{{ props.item.description }}</td>
        <td class="justify-center layout px-0">
          <v-btn icon class="mx-0" @click.native="editRole(props.item.id)"><v-icon>edit</v-icon></v-btn>
          <v-btn icon class="mx-0" @click.native="deleteItem(props.item.id);"><v-icon>delete</v-icon></v-btn>
        </td>
      </template>
      <template slot="no-data">
        <v-alert :value="true" color="error" icon="warning" outline>No data available</v-alert>
      </template>
    </v-data-table>
  </v-flex>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapMutations } from 'vuex'

export default {
  data: function () {
    return {
      loadingState: true,
      headers: [
      { text: 'ID', align: 'left', value: 'id' },
      { text: 'Name', align: 'left', value: 'name' },
      { text: 'Description', align: 'left', value: 'description' },
      { text: '', align: 'left', value: 'actions', sortable: false } ]
    }
  },
  computed: {
    ...mapGetters({
      roles: 'getRoles'
    })
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    getData () {
      this.loadingState = true
      axios.all([this.$store.dispatch('getRoles')]).then(axios.spread((rolesResponse) => {
        this.loadingState = false
        if (rolesResponse.data.status === 'SUCCESS') this.$store.commit('setRoles', rolesResponse.data.payload)
      })).catch((err) => {
        this.loadingState = false
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    editRole (id) {
      this.$router.push('/roles/' + id)
    },
    addRole () {
      this.$router.push('/roles/new')
    },
    deleteItem (id) {
      this.$vuetifyConfirmDialog.open('', 'Are you sure you want to delete this role?', 'Cancel', 'Delete').then(state => {
        if (state) {
          this.loadingState = true
          axios.all([this.$store.dispatch('deleteRole', {id: parseInt(id)})]).then(axios.spread((rolesResponse) => {
            this.loadingState = false
            this.$store.commit('deleteRole', rolesResponse.data.payload)
          })).catch((err) => {
            this.loadingState = false
            this.notify({message: 'Something went wrong while connecting to the server.', show: true})
            console.log(err)
          })
        }
      })
    }
  },
  mounted: function () {
    this.getData()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/roles/RolesTable.vue